import { v4 as uuid } from 'uuid';
import { Box, Grid } from '@mui/material';
import Utils from '../../../../utils/Utils';
import EditableText from '../../../Form/EditableText';
import { BlockTableVariant } from '../BlockTableData';
import BlockTableItemData from '../BlockTableItemData';
import useResponsive from '../../../../hooks/UseResponsive';
import styles from './TableItem.module.css';

interface TableItemProps {
  item: BlockTableItemData;
  isEditing: boolean;
  isTemplate: boolean;
  isFirst?: boolean;
  isHeader?: boolean;
  variant: BlockTableVariant;
  handleUpdateTitle: (text: string) => void;
  handleUpdateText: (text: string) => void;
}

const TableItem = ({
  item, isEditing, isTemplate, isFirst, isHeader, variant, handleUpdateTitle, handleUpdateText,
}: TableItemProps) => {
  const itemId = uuid();
  const defaultStyle = {
    borderTop: isHeader ? '' : '1px solid lightGray',
    borderLeft: '1px solid lightGray',
    marginTop: isFirst || isEditing || isTemplate || variant !== BlockTableVariant.Default ? 0 : '-1px',
  };

  useResponsive({
    items: [
      {
        wrapperId: `table-item-wrapper-${itemId}`,
        targetId: `table-item-title-${itemId}`,
        queries: [
          { size: 0, className: styles.stretch },
          { size: 900, className: styles.split },
        ],
      },
      {
        wrapperId: `table-item-wrapper-${itemId}`,
        targetId: `table-item-text-${itemId}`,
        queries: [
          { size: 0, className: styles.stretch },
          { size: 900, className: styles.split },
        ],
      },
    ],
  });

  return (
    <Grid
      container
      justifyContent="start"
      alignItems="stretch"
      id={`table-item-wrapper-${itemId}`}
      sx={[
        {
          maxWidth: '100%',
        },
        variant === BlockTableVariant.Default ? defaultStyle : null,
      ]}
    >

      {/* Title side */}
      <Grid
        item
        xs={2}
        minWidth={150}
        id={`table-item-title-${itemId}`}
        sx={[{
          borderTop: isHeader ? '1px solid lightGray' : '',
          borderRight: variant === BlockTableVariant.Default ? '1px solid lightGray' : '',
          borderBottom: variant === BlockTableVariant.BorderBottom || (variant === BlockTableVariant.Default && !isHeader) ? '1px solid lightGray' : '',
        },
        ]}
      >
        <Box sx={[Utils.hoverBorder(isEditing), { height: '100%' }]}>
          <EditableText
            text={item.title.value}
            isEditable={isEditing && !isTemplate}
            updateHandler={handleUpdateTitle}
          />
        </Box>
      </Grid>

      {/* Text side */}
      <Grid
        item
        xs={10}
        minWidth={300}
        id={`table-item-text-${itemId}`}
        sx={[
          {
            borderTop: isHeader ? '1px solid lightGray' : '',
            borderRight: variant === BlockTableVariant.Default ? '1px solid lightGray' : '',
            borderBottom: variant === BlockTableVariant.BorderBottom || (variant === BlockTableVariant.Default && !isHeader) ? '1px solid lightGray' : '',
          },
        ]}
      >
        <Box sx={[Utils.hoverBorder(isEditing), { height: '100%' }]}>
          <EditableText
            text={item.text.value}
            isEditable={isEditing && !isTemplate}
            updateHandler={handleUpdateText}
          />
        </Box>

      </Grid>

    </Grid>
  );
};

export default TableItem;
